export const isValidApiUrl = (url: string) => {
  const urlPattern = /^(?:http)(?:s)?(?::\/\/)(?:.*)(?:\.zakaz\.ua)$/i;

  return !!urlPattern.test(url);
};
